import { render, staticRenderFns } from "./DepositForArgentinaTab.vue?vue&type=template&id=06a83f88&scoped=true"
import script from "./DepositForArgentinaTab.vue?vue&type=script&lang=js"
export * from "./DepositForArgentinaTab.vue?vue&type=script&lang=js"
import style0 from "./DepositForArgentinaTab.vue?vue&type=style&index=0&id=06a83f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a83f88",
  null
  
)

export default component.exports